export const APP_START = 'boilerplate/app_start';
export const APP_ERROR = 'APP_ERROR';
export const CHANGE_LOCALE = 'change_locale';
export const APP_INITIALIZATION_END = 'APP_INITIALIZATION_END';
export const LOAD_TRANSLATIONS = 'LOAD_TRANSLATIONS';
export const APP_MESSAGE_UPDATE = 'APP_MESSAGE_UPDATE';
